// Learn TypeScript:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/typescript.html
// Learn Attribute:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/reference/attributes.html
// Learn life-cycle callbacks:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/life-cycle-callbacks.html

import BasePopUpLayer from "../../../../../engines/components/BasePopUpLayer";
import BaseStateSprite from "../../../../../engines/components/state/BaseStateSprite";
import O1HD from "../../../../../engines/gameEngine";
import utilsView from "../../../../../engines/libs/utilsView";
import CsvDataManage from "../../../../../engines/managers/CsvDataManage";
import { UI_Z_INDEX } from "../../../../../engines/modules/uiModule";
import { CsvFileKind } from "../../../../define/CsvFileKind";
import { GeneralKind } from "../../../../define/GeneralKind";
import { MessageEventKind } from "../../../../define/MessageEventKind";
import { UIKind } from "../../../../define/UIKind";
import NormalGameManager from "../../../manager/NormalGameManager";
import UserDataManage from "../../../model/UserDataManage";
import ThruTimeAccessItem from "./ThruTimeAccessItem";

const {ccclass, property} = cc._decorator;

@ccclass
export default class ThruTimeAccessLayer extends BasePopUpLayer {

    @property(cc.Node)
    nodeFirst: cc.Node = null;
    @property(cc.Node)
    nodeShow: cc.Node = null;

    @property(cc.Node)
    nodePointItem: cc.Node = null;
    @property(cc.Node)
    nodePointList: cc.Node = null;
    @property(cc.Node)
    pageItem: cc.Node = null;
    @property(cc.PageView)
    pageView: cc.PageView = null;

    @property(cc.Prefab)
    itemPrefab: cc.Prefab = null;
    
    private curSelectidx = 0;

    private csvInfos:any = null;

    private idLis: string[] = [];
    // LIFE-CYCLE CALLBACKS:

    // onLoad () {}

    start () {
        O1HD.getModules().uiControlModule.hideLoading();
        utilsView.enterLayerDispose(UIKind.UILayerTag.ThruTimeAccessLayer, this.node, ()=> {
            this.initLayer();
        });

        O1HD.on(MessageEventKind.EventName.ENTER_THRU_TIME_LEVEL, this.enterLv, this);

        let gameManager = NormalGameManager._instance;
        let gameData = gameManager.getGameData();
        let bNoFirst = gameData.firstEnterLayer.includes(UIKind.UILayerTag.ThruTimeAccessLayer);

        this.nodeFirst.active = !bNoFirst;
        this.nodeShow.active = bNoFirst;
        if (bNoFirst) {
            this.initLayer();
        }
    }

    protected onDestroy(): void {
        O1HD?.emit("normalMode.onBackNormal", UIKind.UILayerTag.ThruTimeAccessLayer);
    }

    initLayer() {

        let thruTimeData = UserDataManage.instance.thruTimeDataManage.thruTimeData;
        if (thruTimeData.curVersion != GeneralKind.GeneralValue.CUR_THRUN_VERSION) {
            thruTimeData.curVersion = GeneralKind.GeneralValue.CUR_THRUN_VERSION;
            thruTimeData.saveLocalData();

            O1HD.emit(MessageEventKind.EventName.REFRESH_SPECIAL_BTN_STATE);
        }

        let csvInfos = this.csvInfos = CsvDataManage.instance.getCsvData(CsvFileKind.CsvFile.THRU_TIME_LEVEL);
        if (!csvInfos) {
            console.error(`未找到数据 THRU_TIME_LEVEL`);
            return;
        }

        this.nodeFirst.active = false;
        this.nodeShow.active = true;

        this.nodePointItem.active = false;
        this.pageItem.active = false;
        this.initPageView();
        this.showPointList();
    }

    initPageView() {

        const c_pageMax = 6;
        
        let thruTimeDataManage = UserDataManage.instance.thruTimeDataManage;
        let thruTimeData = thruTimeDataManage.thruTimeData;

        let c = 0;
        let curPage: cc.Node = null;

        let csvInfos = this.csvInfos;
        let title = csvInfos.title;
        this.idLis = [];
        for (let i in csvInfos) {
            if (i == 'title' || i == '' || i.trim() == '') {
                continue;
            }
            this.idLis.push(i);
        }
        for (let i in csvInfos) {
            if (i == 'title' || i == '' || i.trim() == '') {
                continue;
            }

            if (c % c_pageMax == 0) {
                curPage = cc.instantiate(this.pageItem);
                curPage.parent = this.pageView.content;
                curPage.y = 0;
                curPage.active = true;
            }

            let info = csvInfos[i];
            let default_open = info[title.default_open];
            if (default_open == GeneralKind.EnableState.ENABLED) {
                thruTimeDataManage.openNewLevel(i);
            }

            let item = cc.instantiate(this.itemPrefab);
            item.parent = curPage;
            item.active = true;

            // let nextId = this.idLis[c+1] || null;
            let itemScript = item.getComponent(ThruTimeAccessItem);
            itemScript.setData(i, c);
            
            c++;
        }
    }

    showPointList() {
        let pointLen = this.pageView.content.children.length;
        for (let i = 0; i < pointLen; i++) {
            let pointItem = cc.instantiate(this.nodePointItem);
            pointItem.active = true;
            pointItem.parent = this.nodePointList;
           
            this.setPointState(i, i == this.curSelectidx);
        }
    }

    setPointState(idx: number, bFill: boolean) {
        let item = this.nodePointList.children[idx];
        if (!item) {
            return;
        }
        let pointScript = item.getChildByName('sprPointItem').getComponent(BaseStateSprite);
        pointScript.setFill(bFill);
    }

    onPaging(pageView: cc.PageView) {
        let idx = pageView.getCurrentPageIndex();
        this.setPointState(this.curSelectidx, false);
        this.curSelectidx = idx;
        this.setPointState(this.curSelectidx, true);
    }

    enterLv(idIdx: number, bNext: boolean) {

        let csvInfos = this.csvInfos;
        let title = csvInfos.title;
        if (bNext) {
            idIdx = idIdx+1;
        }
        let curLevelId = this.idLis[idIdx];
        if (!curLevelId) {
            console.error(`未找到关卡 idIdx = ` + idIdx);
            return;
        }

        let info = csvInfos[curLevelId];
        if (!info) {
            console.error(`未找到关卡数据 id = `, curLevelId);
            return;
        }

        let bundleName = info[title.level_bundle];
        let level_path = info[title.level_path];
        let nextId = this.idLis[idIdx+1] || null;
        O1HD.getModules().uiControlModule.showLoading();
        utilsView.openPopupLayer(
            level_path
            , bundleName
            , null
            , {
                levelId: curLevelId
                , nextId: nextId
                , idIdx: idIdx
            }
            , UI_Z_INDEX.DIALOG
            , null
            , false
        )
    }

    onClickClose() {
        O1HD.getManagers().soundMgr.playSound("anNiu");
        this.destroyNode();
    }

    // update (dt) {}
}
